<template>
  <div class="grid grid-cols-4">
    <a
      class="relative m-auto"
      href="https://www.linkedin.com/in/prayog-paudel-4aa6b4165/"
      target="_blank"
    >
      <transition
        name="icon-transition"
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__faster"
      >
        <span
          v-show="showToolTip['linkedin']"
          class="text-xs absolute border-solid border-2 rounded p-1 background-white translate-linkedin"
        >
          LinkedIn
        </span>
      </transition>
      <svg
        width="3rem"
        height="3rem"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hover-color pointer"
        @mouseover="showToolTip = { ...showToolTip, linkedin: true }"
        @mouseleave="showToolTip = { ...showToolTip, linkedin: false }"
      >
        <g id="24 / symbols / linkedin">
          <path
            id="icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.1667 6H61.5C64.9058 6 67.6667 8.76091 67.6667 12.1667V61.5C67.6667 64.9058 64.9058 67.6667 61.5 67.6667H12.1667C8.76091 67.6667 6 64.9058 6 61.5V12.1667C6 8.76091 8.76091 6 12.1667 6ZM12.1667 12.1667V61.5H61.5V12.1667H12.1667ZM39.9167 27.5833C38.3203 27.5833 36.6337 28.0713 35.1441 28.9775L33.75 27.5833H30.6667V49.1667H36.8333V36.8333C36.8333 35.0581 38.6647 33.75 39.9167 33.75H43C44.252 33.75 46.0833 35.0581 46.0833 36.8333V49.1667H52.25V36.8333C52.25 31.1205 47.298 27.5833 43 27.5833H39.9167ZM24.5 24.5C26.2029 24.5 27.5833 23.1195 27.5833 21.4167C27.5833 19.7138 26.2029 18.3333 24.5 18.3333C22.7971 18.3333 21.4167 19.7138 21.4167 21.4167C21.4167 23.1195 22.7971 24.5 24.5 24.5ZM21.4167 49.1667H27.5833V27.5833H21.4167V49.1667Z"
            class="fill-primary"
          />
        </g>
      </svg>
    </a>
    <a
      class="relative m-auto"
      href="https://github.com/ppaudel93"
      target="_blank"
    >
      <transition
        name="icon-transition"
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__faster"
      >
        <span
          v-show="showToolTip['github']"
          class="text-xs absolute border-solid border-2 rounded p-1 background-white translate-github"
        >
          Github
        </span>
      </transition>
      <svg
        width="3rem"
        height="3rem"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hover-color pointer"
        @mouseover="showToolTip = { ...showToolTip, github: true }"
        @mouseleave="showToolTip = { ...showToolTip, github: false }"
      >
        <g id="24 / symbols / github">
          <path
            id="icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.8865 61.6779C30.9025 62.0567 30.8616 62.4263 30.7819 62.8004C30.6417 63.4578 30.371 64.1534 29.9879 64.7961C28.8988 66.6232 27.0487 67.8424 24.6667 67.8424C19.0553 67.8424 16.853 65.0895 14.0955 58.1958C12.228 53.527 11.347 52.4257 9.25 52.4257L9.25 46.259C14.8614 46.259 17.0637 49.0119 19.8211 55.9056C21.6887 60.5744 22.5697 61.6757 24.6667 61.6757C24.6667 60.781 24.6544 59.9885 24.6286 58.9153C24.5682 56.3999 24.5612 55.8864 24.671 55.214C24.7148 53.746 25.0938 52.7044 25.8537 51.6707C18.9723 50.1727 14.3311 47.0789 11.6673 42.061L10.6694 39.7143C9.69722 36.9205 9.25 33.7549 9.25 30.099C9.25 25.8885 10.5337 22.1238 12.9316 18.9769C12.1836 15.9856 12.286 12.3309 13.9376 8.20351L14.4773 6.85485L15.8609 6.41227C16.0461 6.35302 16.2713 6.2995 16.5359 6.25798C19.23 5.83513 23.0637 6.844 28.0754 10.0543C31.0299 9.36938 34.1413 9.02359 37.2737 9.02359C40.073 9.02359 42.8567 9.30579 45.515 9.86215C50.3911 6.80863 54.1194 5.85092 56.741 6.25852C57.0026 6.29918 57.2255 6.35167 57.4092 6.40993L58.8014 6.85142L59.3417 8.20831C60.7865 11.8366 61.0345 15.1804 60.5088 18.1062C63.2653 21.4138 64.75 25.48 64.75 30.099C64.75 33.993 64.471 36.9211 63.6691 39.7697L62.8226 42.0926C60.6069 47.1052 55.7203 50.2336 48.1849 51.7237C48.9681 52.8081 49.3333 53.909 49.3333 55.509V58.5924C49.3333 60.0866 49.3333 60.1326 49.3299 61.6757C49.3369 61.7865 49.3462 61.8408 49.3563 61.8746C49.3538 61.8754 49.3333 67.8424 49.3333 67.8424C46.707 67.8424 44.7542 66.5615 43.7937 64.5411C43.2958 63.4936 43.147 62.4934 43.1667 61.6319V55.509C43.1667 55.2505 43.1577 55.2355 42.5281 54.6059C40.8452 52.923 40.0833 51.6533 40.0833 49.3424V46.5532L42.8586 46.2745C51.1196 45.4448 55.6127 43.1507 57.1023 39.7992L57.7985 37.896C58.3524 35.9061 58.5833 33.4827 58.5833 30.099C58.5833 26.5035 57.3281 23.5334 54.9542 21.1605L53.6494 19.8562L54.182 18.0898C54.6551 16.5205 54.7675 14.6637 54.267 12.5458C54.1838 12.5668 54.0974 12.5898 54.0076 12.6148C52.3567 13.0744 50.2954 14.0607 47.8115 15.721L46.6786 16.4782L45.356 16.1503C42.7979 15.5159 40.049 15.1903 37.2737 15.1903C34.1876 15.1903 31.1369 15.5829 28.3187 16.3512L26.9434 16.7262L25.7669 15.9213C23.1978 14.1638 21.0636 13.1187 19.3523 12.6304C19.2301 12.5956 19.1137 12.5644 19.0031 12.5366C18.406 14.9878 18.6422 17.0017 19.2469 18.5128L19.9719 20.3247L18.6446 21.7554C16.5294 24.0352 15.4167 26.8095 15.4167 30.099C15.4167 33.1106 15.7692 35.6062 16.4153 37.486L17.2222 39.3959C19.2392 43.1808 23.5234 45.4578 31.162 46.2766L33.9167 46.5719V49.3424C33.9167 51.6533 33.1548 52.923 31.4719 54.6059C30.8423 55.2355 30.8333 55.2505 30.8333 55.509L30.7802 56.079C30.745 56.266 30.745 56.7487 30.7935 58.7672C30.8158 59.6955 30.8285 60.4303 30.8322 61.1981C30.869 61.3571 30.8746 61.4596 30.8865 61.6779Z"
            class="fill-primary"
          />
        </g>
      </svg>
    </a>
    <a
      class="relative m-auto"
      href="https://www.instagram.com/someonetookmyname_/"
      target="_blank"
    >
      <transition
        name="icon-transition"
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__faster"
      >
        <span
          v-show="showToolTip['instagram']"
          class="text-xs absolute border-solid border-2 rounded p-1 background-white translate-instagram"
        >
          Instagram
        </span>
      </transition>
      <svg
        width="3rem"
        height="3rem"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hover-color pointer"
        @mouseover="showToolTip = { ...showToolTip, instagram: true }"
        @mouseleave="showToolTip = { ...showToolTip, instagram: false }"
      >
        <g id="24 / symbols / instagram">
          <path
            id="icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M49.3333 6.16666H24.6667C14.4494 6.16666 6.16666 14.4494 6.16666 24.6667V49.3333C6.16666 59.5506 14.4494 67.8333 24.6667 67.8333H49.3333C59.5506 67.8333 67.8333 59.5506 67.8333 49.3333V24.6667C67.8333 14.4494 59.5506 6.16666 49.3333 6.16666ZM12.3333 24.6667C12.3333 17.8551 17.8551 12.3333 24.6667 12.3333H49.3333C56.1448 12.3333 61.6667 17.8551 61.6667 24.6667V49.3333C61.6667 56.1448 56.1448 61.6667 49.3333 61.6667H24.6667C17.8551 61.6667 12.3333 56.1448 12.3333 49.3333V24.6667ZM37 52.4167C28.4856 52.4167 21.5833 45.5144 21.5833 37C21.5833 28.4856 28.4856 21.5833 37 21.5833C45.5144 21.5833 52.4167 28.4856 52.4167 37C52.4167 45.5144 45.5144 52.4167 37 52.4167ZM37 46.25C42.1086 46.25 46.25 42.1086 46.25 37C46.25 31.8914 42.1086 27.75 37 27.75C31.8914 27.75 27.75 31.8914 27.75 37C27.75 42.1086 31.8914 46.25 37 46.25ZM55.5 21.5833C55.5 23.2862 54.1195 24.6667 52.4167 24.6667C50.7138 24.6667 49.3333 23.2862 49.3333 21.5833C49.3333 19.8804 50.7138 18.5 52.4167 18.5C54.1195 18.5 55.5 19.8804 55.5 21.5833Z"
            class="fill-primary"
          />
        </g>
      </svg>
    </a>
    <a
      class="relative m-auto"
      href="https://twitter.com/PRAYOG_"
      target="_blank"
    >
      <transition
        name="icon-transition"
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__faster"
      >
        <span
          v-show="showToolTip['twitter']"
          class="text-xs absolute border-solid border-2 rounded p-1 background-white translate-twitter"
        >
          Twitter
        </span>
      </transition>
      <svg
        width="3rem"
        height="3rem"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hover-color pointer"
        @mouseover="showToolTip = { ...showToolTip, twitter: true }"
        @mouseleave="showToolTip = { ...showToolTip, twitter: false }"
      >
        <g id="24 / symbols / twitter">
          <path
            id="icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M63.9519 15.7338L68.314 16.2433L66.3532 20.173C65.397 22.0894 64.4398 24.0057 63.4817 25.9221C63.3681 26.328 63.1684 26.6838 62.8731 27.1471C62.7497 27.3407 62.3281 27.9564 62.3084 27.986C62.1971 28.1529 62.1148 28.2846 62.0556 28.39V35.7547C62.0556 54.6 43.8177 66.5754 26.5942 66.5754C23.0699 66.5754 20.3922 66.4065 17.3261 65.7374C12.2802 64.6363 8.52509 62.4475 6.80675 58.6221L5.03765 54.6837L9.33698 54.2883C13.2264 53.9307 16.5985 53.1897 19.1882 52.1975C12.0786 51.0541 8.09443 47.9316 8.09443 42.0674V38.9841H11.1778C11.8552 38.9841 12.4661 38.9291 13.0122 38.8282C7.67634 35.6379 5.00377 30.52 5.00377 23.4214C5.00318 23.1188 5.00318 23.1188 5.00136 22.7953C4.98132 19.2172 5.17351 17.3054 6.15301 14.8653C6.78076 13.3015 7.68815 11.8538 8.90936 10.5273L11.2361 8L13.4982 10.5853C20.953 19.105 28.3222 24.2737 35.8462 24.8989C35.8783 17.0374 41.8197 11.088 49.7217 11.088C53.4055 11.088 56.747 12.4863 59.373 15.0076C60.8102 15.3029 62.3366 15.5452 63.9519 15.7338ZM57.135 20.8329L56.1897 20.6188L55.537 19.9025C53.9586 18.1705 51.9775 17.2547 49.7217 17.2547C45.2109 17.2547 42.0127 20.4687 42.0127 24.963C42.0127 25.6975 41.9937 26.159 41.9022 26.7656C41.5371 29.1861 40.1795 31.1297 37.3876 31.1297C28.1437 31.1297 19.8042 26.1775 11.672 17.7195C11.2528 18.994 11.1542 20.304 11.1679 22.7607C11.1698 23.0893 11.1698 23.0893 11.1704 23.4214C11.1704 29.736 13.7287 33.1901 19.786 35.1154L21.9354 35.7986V38.0539C21.9354 40.7888 19.3443 43.3632 15.5533 44.5163C17.2911 45.8348 20.8453 46.5464 26.5953 46.5464H29.6787V49.6297C29.6787 54.0473 24.6027 57.5062 16.9348 59.3124C19.4355 60.0785 22.7651 60.4087 26.5942 60.4087C40.822 60.4087 55.8889 50.5155 55.8889 35.7547V28.0464C55.8889 27.1405 56.1515 26.3543 56.5877 25.5367C56.7583 25.2171 56.9461 24.9124 57.1778 24.5648C57.2214 24.4994 57.3833 24.2623 57.5118 24.0728L57.7562 23.5841C58.1522 22.7921 58.548 22.0002 58.9437 21.2083C58.3288 21.0918 57.7259 20.9667 57.135 20.8329Z"
            class="fill-primary"
          />
        </g>
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showToolTip: {},
    }
  },
}
</script>

<style>
.pointer:hover {
  cursor: pointer;
}
.translate-linkedin {
  transform: translate(-6%, -119%);
}
.translate-github {
  transform: translate(-1%, -119%);
}
.translate-instagram {
  transform: translate(-16%, -119%);
}
.translate-twitter {
  transform: translate(-5%, -119%);
}
</style>
